export const environment = {
  production: true,
  msalRedirectUrl: '__REDIRECT_URL__',
  version: require('../../package.json').version,
  env: '__ENVIRONMENT__'
};
